<template>
  <div>
    Data generator mission aims to generate virtual SP ephemeris, to do this the user has multiple choice:
    <ul>
      <br />
      <li>
        <b>Ballistic propagation</b>:
        To do only one ballistic propagation the user can define a target date, Data generator mission will do a ballistic propagation of the initial orbit between to the target date.
      </li>
      <li>
        <b>Maneuver</b>:
        To do one maneuver, the user have to define two different orbits the data generator will build a maneuver to reach the target orbit without take in account orbit date.
      </li>
      <br />
    </ul>
    At the end of simulation, the mission generate SP ephemeris over the simulation. In order to fit real SP ephemeris, the generated ephemeris have the following parameter:
    <ul>
      <br />
      <li>
        1 day time step for orbit determination date
      </li>
      <li>
        At each orbit determination date, ephemeris over 5 day as ballistic propagation is provided.
      </li>
      <li>
        Ephemeris has 2min time step between each data.
      </li>
      <br />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipDataGeneratorMission'
}
</script>
